export const householdListBundle = {
  unitAddress: {
    ko: "{dong}동 {ho}호",
    en: "Bldg {dong} Unit {ho}",
    es: "Edif. {dong} Unidad {ho}"
  },
  emptyMessage: {
    ko: "등록된 세대가 없습니다.",
    en: "No registered units found",
    es: "No se encontraron unidades registradas"
  }
}
